const filters = {
  // highlight(words, query) {
  // 	String.prototype.replaceAllIgnoreCase = function (strReplace, strWith) {
  // 		var esc = strReplace.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  // 		var reg = new RegExp(esc, 'ig');
  // 		return this.replace(reg, strWith);
  // 	};
  //
  // 	if (query && `${words}`.indexOf('ignore-filter-highlight') === -1) {
  // 		if (typeof words === 'object') words = JSON.stringify(words);
  // 		words = `${words}`.replaceAll(query, "<span class='highlight'>" + query + '</span>');
  // 	}
  // 	return words;
  // },
};
export default filters;
